import { useMemo } from 'react';

import type { WalletNetwork } from '@api';

import { useSession } from './query/session';

const useMagicIdWallet = (targetNetwork: WalletNetwork = 'EVM') => {
  // NOTE: the same as { user } = useAuth()
  // useSession is used to make useUserWalletInfo reusable without using AuthProvider
  const { session, query } = useSession();

  const userWallet = useMemo(
    () => session.user?.wallets?.find((wallet) => wallet.attributes.network === targetNetwork),
    [session.user, targetNetwork],
  );

  const isAuthed = !!session.user;

  return {
    user: session.user,
    userWallet,
    isLoadingUser: query.isFetching,
    isAuthed,
  };
};

export default useMagicIdWallet;
